import React, { useState } from 'react';
import { Modal, Form, Input, Button, message } from 'antd';

const CambiarPasswordModal = ({ visible, onCancel, onOk, empleado, loading }) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      setSubmitting(true);
      await onOk(values.nuevaPassword);
      setSubmitting(false);
      form.resetFields();
    } catch (err) {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      visible={visible}
      title={`Cambiar contraseña de ${empleado?.nombre || ''}`}
      onCancel={() => { form.resetFields(); onCancel(); }}
      onOk={handleOk}
      confirmLoading={submitting || loading}
      okText="Actualizar"
      cancelText="Cancelar"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label="Nueva contraseña"
          name="nuevaPassword"
          rules={[
            { required: true, message: 'La contraseña es obligatoria' },
            { min: 8, message: 'Debe tener al menos 8 caracteres' },
            { pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).+$/, message: 'Debe contener mayúsculas, minúsculas y números' }
          ]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>
        <Form.Item
          label="Confirmar contraseña"
          name="confirmPassword"
          dependencies={["nuevaPassword"]}
          rules={[
            { required: true, message: 'Confirma la contraseña' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('nuevaPassword') === value) {
                  return Promise.resolve();
                }
                return Promise.reject('Las contraseñas no coinciden');
              },
            }),
          ]}
        >
          <Input.Password autoComplete="new-password" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CambiarPasswordModal;
